











import Vue from "vue";
import { t } from "@/plugins/i18n";

interface Props {
  /** A körbevett mező tiltott-e — csak ekkor jelenik meg a magyarázat. */
  disabled: boolean;
  tooltip: string;
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    disabled: { type: Boolean, default: false },
    tooltip: {
      type: String,
      default: t("Interface_AMezoErtekeNemModosithato"),
    },
  },
});
